import Chart from "chart.js";

// získání dat z backendu

export const getData = (url, callbackOk, callbackNok) => {
  const oReq = new XMLHttpRequest();

  oReq.onload = function(e) {
    callbackOk(e, oReq);
  };

  oReq.onerror = function(e, oReq) {
    callbackNok(e, oReq);
  };

  oReq.onabort = function(e, oReq) {
    callbackNok(e, oReq);
  };

  oReq.open("GET", url);
  oReq.send();
};

// vytvoření grafu

let chartInstance = {};

export const destroyChartAtIndex = (chartIndex) => {
  if (chartInstance[chartIndex]) {
    chartInstance[chartIndex].destroy();
  }
}

export const createChart = (canvas, data, dataset, chartIndex) => {
  destroyChartAtIndex();

  canvas.setAttribute("style", `height:${dataset.bdchartheight || 500}px`);
  canvas.removeAttribute("height");
  canvas.removeAttribute("width");

  const ctx = canvas.getContext('2d');

  chartInstance[chartIndex] = new Chart(ctx, {
    type: data.type || "bar",
    data: data.data,
    options: data.options || {
      title: {
        display: true,
        text: data.title,
        position: "left"
      },
      legend: {
        position: "bottom",
        labels: {
          filter: (item, chart) => item.text,
          usePointStyle: true,
          padding: 20
        }
      },
      tooltips: {
        mode: "index",
        filter: (item, chart) => chart.datasets[item.datasetIndex].label,
        intersect: true
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false
            },
            maxBarThickness: 2
          }
        ],
        yAxes: [
          {
            ticks: {
              stepSize: 100,
              // beginAtZero: true
              min: data.yMin || undefined
            }
          }
        ]
      }
    }
  });

}
